import { RefObject, useEffect, useState } from "react";

import useThrottle from "hooks/useThrottle";

export const useDetectHalfUp = (ref: RefObject<HTMLDivElement | null>) => {
  const [isHalfUp, setIsHalfUp] = useState(true);

  const onScroll = useThrottle(() => {
    const viewPortTop = ref.current?.getBoundingClientRect();
    const clientHeight = window?.innerHeight;
    if (!viewPortTop || !clientHeight) return;
    setIsHalfUp(viewPortTop.top < clientHeight / 2);
  }, 1000);

  useEffect(() => {
    if (!ref?.current) return;
    onScroll();
    document.addEventListener("scroll", onScroll);
    return (): void => document.removeEventListener("scroll", onScroll);
  });

  return { isHalfUp };
};
